<template>
  <div class="return-layout return">
    <div class="return-section pb-2">
      <div v-if="success">
        <div class="result">
          <img src="@/assets/img/return/send-success.svg" />
          <h1>申請成功</h1>
        </div>
        <div v-if="isRedmption" class="result-info">
          <h2>退款注意事項：</h2>
          <ul>
            <li>退貨申請確認信（含退貨須知），已寄至您的電子信箱，請前往確認。</li>
            <li>待我們審核完後，將會以電子郵件再通知您。</li>
            <li>上述步驟皆完成後，退款金額將直接透過 Pi 拍錢包退款，退款作業時間請參照 Pi 拍錢包內「關於 Pi 拍錢包」條款，麻煩耐心等候。</li>
            <li>退貨處理時間為10~15天，您可以於「電子票券」→「退款」，點選訂單號碼即可進入「訂單明細」查詢，隨時了解您的退貨狀態。</li>
          </ul>
        </div>
        <div v-else class="result-info">
          <h2>恭喜您完成退貨申請，為提供您更快速的退貨服務，請完成以下步驟：</h2>
          <ul>
            <li>退貨申請確認信（含退貨需知），已寄至您的電子信箱，請前往確認。</li>
            <li>請將商品重新妥善包裝，我們將通知廠商盡速取回；若您還沒收到欲退貨的商品，我們將請廠商取消出貨，可能因時間差來不及取消出貨，請您拒收即可。</li>
            <li>待廠商確認無誤後，我們將會以電子郵件再通知您。</li>
            <li>上述步驟皆完成後，退款金額將直接退至您的信用卡內，因各家銀行作業時間不同，您應可於下一期信用卡帳單看到此退款（視信用卡結帳週期而定），請您耐心等候。</li>
            <li>退貨處理時間為10~20天，您可以於【宅配進度】→【退貨】，點選訂單號碼即可進入【訂單明細】查詢，隨時了解您的退貨狀態。</li>
          </ul>
        </div>
      </div>
      <div v-else>
        <div class="result">
          <img src="@/assets/img/return/send-fail.svg" />
          <h1>申請失敗</h1>
        </div>
        <div class="result-info">
          <p>康太數位服務專線：（02）7729-9040</p>
          <p>服務時間：週一~週五 09:00-18:00</p>
        </div>
      </div>
      <v-btn
        class="my-2 justify-center"
        color="primary"
        block
        @click="goPiHome"
        depressed="true"
      >
        返回首頁
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReturnResult',
  data() {
    return {
      productType: 0, // redemption: 0 , delivery: 1
      isAtmRefund: false,
      success: true,
    }
  },
  mounted() {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.myBack, false)
  },
  created() {
    this.success = this.$route.query.success
    this.productType = this.$route.query.type
    this.isAtmRefund = this.$route.query.isAtmRefund
  },
  methods: {
    myBack() {
      history.pushState(null, null, document.URL)
    },
    goPiHome() {
      window.location = process.env.VUE_APP_E7G_HOME
    },
  },
  computed: {
    isRedmption() {
      return this.productType == 0
    },
  },
  destroyed() {
    window.removeEventListener('popstate', this.myBack, false)
    window.onpopstate = () => {}
  },
}
</script>

<style scoped lang="scss">
.return-layout {
  background-color: #f3f3f3;

  .return-section {
    background-color: white;
    padding: 16px;
  }

  .stepper-container {
    padding: 0 20px;
  }
}
.result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-weight: bold;
  font-size: 18px;
  & .text-green {
    color: #56ca39;
  }
  & .text-red {
    color: #f04c44;
  }
  h1 {
    font-family: 'PingFangTC';
    font-size: 22px;
    font-weight: 500;
    color: #2a2b2b;
    margin-bottom: 40px;
  }
}

.result-info {
  border-top: 2px solid #d9dbde;
  padding: 16px 0;
  margin-bottom: 32px;
  h2 {
    font-family: 'PingFangTC';
    font-size: 14px;
    color: #2a2b2b;
    margin-bottom: 8px;
    font-weight: normal;
  }
  ul {
    list-style: none;
    padding-left: 16px;
    li {
      position: relative;
      color: #8e9091;
      font-family: 'PingFangTC';
      font-size: 14px;
      line-height: 1.57;
      margin-bottom: 4px;
      &:after {
        content: '';
        background-color: #8e9091;
        border-radius: 50%;
        width: 2px;
        height: 2px;
        left: -7px;
        top: 9px;
        position: absolute;
      }
    }
  }
  p {
    font-family: 'PingFangTC';
    font-size: 14px;
    color: #8e9091;
  }
}

.v-btn {
  height: 48px;
  border-radius: 8px;
  font-family: 'PingFangTC';
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.4px;
}
</style>
